import {h, Fragment} from "preact"
import { useAppState, useSelectedFiltersCount, useSort } from "@nosto/preact"
import { useEffect } from "preact/hooks"
import { sortOptions } from "../config"
import Icon from "./elements/Icon"
import Select from "./elements/Select"

function ToggleMobileSidebarButton({ lableFor, selectedFiltersCount, className }) {
    return (
        <label
            for={lableFor}
            className={`nosto-toggle-button ns-act-btn ns-filters ns-d-inline-flex ns-d-md-none ns-text-align-center ns-align-items-center ${className}`}
        >
            <svg aria-label="Filter icon" class="icon icon--filter" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 3.5H16" stroke="currentColor" stroke-width="1.2"></path>
                <path d="M0 10.5H16" stroke="currentColor" stroke-width="1.2"></path>
                <rect x="0.6" y="1.6" width="3.8" height="3.8" fill="white" class="filter-icon__top-handle"></rect>
                <rect x="0.6" y="1.6" width="3.8" height="3.8" stroke="currentColor" stroke-width="1.2" class="filter-icon__top-handle"></rect>
                <path d="M11.6 8.6H15.4V12.4H11.6V8.6Z" fill="white" class="filter-icon__bottom-handle"></path>
                <path d="M11.6 8.6H15.4V12.4H11.6V8.6Z" stroke="currentColor" stroke-width="1.2" class="filter-icon__bottom-handle"></path>
            </svg>
            <span style="font-size: 14px; text-transform: uppercase; margin-left: 10px;">REFINE</span>
        </label>
    )
}

export default function Toolbar({ lableFor }) {
    const { loading, query, response, pageType } = useAppState()
    const { activeSort, setSort } = useSort(sortOptions)
    const selectedFiltersCount = useSelectedFiltersCount()

    const handleSortChange = event => {
        setSort(event.target.value)
    }

    const docCount = response.products?.total ?? 0

    const totalSummary = pageType === "category" ? `${document.querySelector(".nosto_category .category_string").textContent}` : `${query.query}`

    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    useEffect(()=>{
        if (window.outerWidth <= 768) {
            const header = document.querySelector("header");
            const filterBar = document.querySelector(".ns-header-controls");
        
            if (header) {
                filterBar.style.top = `${header.offsetHeight}px`;
            }
        }
    })

    return (
        <div
            class="ns-header-controls nosto-facet-bar ns-d-flex ns-flex-row ns-flex-md-row ns-d-none ns-d-md-flex  ns-flex-wrap align-center ns-justify-content-between ns-pt-o ns-pr-3 ns-pb-1 ns-pl-3"
            style={loading ? "opacity: 0.3; justify-content: end !important;" : ""}
        >
            {!loading && (
                <div class="results__title-count" style="display: flex !important; order: 1; ">
                <h3
                    class="ns-d-inline ns-text-align-left ns-order-3 ns-d-md-block ns-order-md-first ns-align-self-md-center"
                    data-nosto-element="totalResults"
                    style="color: rgb(77, 83, 88) !important; order: 1;"
                >
                    {totalSummary}
                </h3>
                <div class="results__count" style="order: 2;" data-results-count="">{docCount}</div>
                </div>
            )}
            <div class="nosto-togglebutton-container ns-d-flex ns-flex-wrap ns-justify-content-between ns-d-md-block nos-w-100" style="order: 2;">
                <ToggleMobileSidebarButton
                    lableFor={lableFor}
                    selectedFiltersCount={selectedFiltersCount}
                />
                {/* <Select
                    value={activeSort}
                    onChange={e => handleSortChange(e)}
                    className="ns-selection-dropdown-sort-menu"
                    options={options}
                /> */}
            </div>
        </div>
    )
}
